import type { CityConfig } from "../city-template/types";

export const wausauConfig: CityConfig = {
  city: "Wausau",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "wausau",
  route: "/cities/wausau",
  title: "Emergency Passport Wausau, WI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Wausau, Wisconsin — as fast as 24 hours. Fast passport renewal and new passport applications for Wausau, Rib Mountain, Rothschild, Schofield, and all Marathon County residents. A+ BBB rated registered courier with access to Chicago Passport Agency.",
  h1: "Emergency & Expedited Passport Services in Wausau, WI",
  heroSubtitle: "Wausau and central Wisconsin have no local passport agency — the nearest is Chicago, about 240 miles southeast. Fast Passport Center's registered couriers deliver your documents directly to the Chicago Passport Agency, getting you a new or renewed passport as fast as 24–48 hours without the nearly 8-hour roundtrip drive.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wausau%20Wisconsin%20downtown%20skyline%20along%20the%20Wisconsin%20River%20with%20Rib%20Mountain%20rising%20in%20the%20background%2C%20historic%20downtown%20district%20with%20Granite%20Peak%20ski%20area%20visible%20on%20the%20horizon%2C%20vibrant%20autumn%20colors%20with%20red%20and%20gold%20foliage%20across%20the%20river%20valley%2C%20warm%20afternoon%20light%20casting%20long%20shadows%2C%20professional%20landscape%20photography%20with%20rich%20earthy%20tones%2C%20classic%20central%20Wisconsin%20river%20town%20scenery%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20and%20nature%20photography&width=1800&height=700&seq=wausau-wi-hero-001&orientation=landscape",
  heroImageAlt: "Wausau Wisconsin downtown along Wisconsin River with Rib Mountain in background",
  geoPosition: "44.9591;-89.6301",
  geoPlacename: "Wausau, Wisconsin",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 240 miles from Wausau — about 4 hours via I-39 and I-90 southeast",
  },
  nearbyCitiesZips: [
    { name: "Downtown Wausau", zips: "54401, 54403" },
    { name: "Rib Mountain", zips: "54401" },
    { name: "Rothschild", zips: "54474" },
    { name: "Schofield", zips: "54476" },
    { name: "Weston", zips: "54476" },
    { name: "Mosinee", zips: "54455" },
    { name: "Kronenwetter", zips: "54455" },
    { name: "Merrill", zips: "54452" },
    { name: "Stevens Point", zips: "54481" },
    { name: "Marshfield", zips: "54449" },
    { name: "Antigo", zips: "54409" },
    { name: "Tomahawk", zips: "54487" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — no 8-hour roundtrip from Wausau required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for central Wisconsin" },
    { icon: "ri-building-line", title: "Central WI Hub", desc: "Serving Wausau, Stevens Point, Marshfield, Merrill, and all Marathon County" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx location in the Wausau area" },
  ],
  internalLinks: [
    { name: "Expedited passport in Eau Claire, WI", route: "/cities/eau-claire" },
    { name: "Emergency passport help in Green Bay, WI", route: "/cities/green-bay" },
    { name: "Urgent passport services in Madison, WI", route: "/cities/madison-wi" },
    { name: "Wisconsin passport services overview", route: "/states/wisconsin" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Wausau, Wisconsin via secure registered courier to the Chicago Passport Agency (230 S Dearborn St, Chicago). Approximately 240 miles — about a 4-hour drive via I-39 and I-90. Wausau's position in the heart of central Wisconsin, with direct interstate access via I-39, makes overnight shipping reliable. We handle the Chicago drive so Wausau and Marathon County residents never need to navigate downtown Chicago traffic.",
  fpcOfficeDistance: "Serving Wausau, Rib Mountain, Rothschild, Schofield, Weston, Mosinee, Kronenwetter, Merrill, Stevens Point, Marshfield, Antigo, Tomahawk, and all central Wisconsin communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Wausau and central Wisconsin. From the historic downtown riverfront and Rib Mountain area to surrounding communities like Rothschild, Schofield, and Stevens Point — we serve all of Marathon County and north-central Wisconsin with direct courier access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Wausau and all nearby central Wisconsin communities including Rib Mountain, Rothschild, Schofield, Weston, Mosinee, Kronenwetter, Merrill, Stevens Point, Marshfield, Antigo, and Tomahawk. Wausau's position as the largest city in north-central Wisconsin makes it the natural hub for expedited passport services in the region.",
  howItWorksIntro: "Most Wausau travelers — especially central Wisconsin professionals, insurance industry employees, and area families — complete everything online and ship documents via overnight courier from any UPS or FedEx in the Wausau area. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Wausau is the gateway to northern Wisconsin with a strong business community — but being over 4 hours from the nearest passport agency creates real challenges. Here are the most common mistakes we see from central Wisconsin travelers.",
  testimonialsIntro: "Wausau travelers — from Marathon County professionals to central Wisconsin families to Northcentral Technical College students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Wausau, WI? Here are the most common ones we hear from central Wisconsin and Marathon County travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://www.dot.wisconsin.gov/drivers",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Agency courier — no 8-hour drive", "Predictable turnaround for central WI travelers", "Ideal for CWA Airport departures", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service USPS", "Good for planned travel from CWA or MSP", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Drive 240 miles to Chicago Passport Agency", "8-hour roundtrip from Wausau"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Wausau travelers with flights within 72 hours — our couriers hand-deliver to Chicago Passport Agency, as fast as 24 hours. Skip the 8-hour roundtrip drive.",
      bullets: ["24–48 hour turnaround available", "No 8-hour roundtrip to Chicago", "Central Wisconsin's fastest passport option"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Wausau adults with a passport issued within the last 15 years. Ideal for central Wisconsin professionals and Marathon County commuters.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Serving all of Marathon County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Wausau residents, central Wisconsin families, and Northcentral Technical College students.",
      bullets: ["Acceptance facility scheduling near Wausau", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Wausau residents — whether lost at home, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Wausau and Marathon County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Wausau and central Wisconsin residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Wausau WI", description: "Urgent passport processing for Wausau Wisconsin travelers via Chicago Passport Agency courier." },
    { name: "Expedited Passport Renewal Wausau WI", description: "Fast passport renewal for Wausau and Marathon County Wisconsin residents." },
    { name: "First-Time Passport Wausau WI", description: "New passport application services for Wausau Wisconsin residents and central Wisconsin families." },
    { name: "Child Passport Wausau WI", description: "Minor passport services for Wausau Wisconsin families with children under 16." },
  ],
  testimonials: [
    {
      name: "Karen J.",
      location: "Wausau, WI — Downtown River District",
      rating: 5,
      text: "Insurance conference in London with 5 days notice. My passport had expired during COVID and I never renewed. Fast Passport Center got me sorted in 48 hours. No way I was driving 8 hours roundtrip to Chicago.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David M.",
      location: "Rothschild, WI",
      rating: 5,
      text: "Family cruise out of Miami in 10 days and my wife's passport was expired. Fast Passport Center expedited her renewal and we had it back in 4 days. The courier to Chicago saved us an entire day of driving.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Nicole P.",
      location: "Stevens Point, WI",
      rating: 5,
      text: "UW-Stevens Point student heading to study abroad in Japan. Needed my first passport fast. Fast Passport Center walked me through everything — from the DS-11 form to finding an acceptance facility near campus. Passport arrived in 5 days.",
      service: "First-Time Passport",
    },
    {
      name: "Mark R.",
      location: "Merrill, WI",
      rating: 5,
      text: "Lost my passport right before a hunting trip to Canada. Fast Passport Center replaced it in 48 hours. Living in central Wisconsin, the courier service to Chicago is a game-changer. Saved me a full day of driving.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "wausau-1",
      name: "Wausau Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "235 Forest St",
      city: "Wausau",
      state: "WI",
      zip: "54403",
      phone: "(715) 845-2066",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "Downtown Wausau, near the riverfront",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for central Wisconsin. Appointment required. Call ahead during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "wausau-2",
      name: "Marathon County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "500 Forest St",
      city: "Wausau",
      state: "WI",
      zip: "54403",
      phone: "(715) 261-1500",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Wausau, Marathon County Courthouse",
      website: "https://www.co.marathon.wi.us/",
      websiteLabel: "Marathon County",
      notes: "County clerk passport acceptance. Convenient downtown location. No photo services on-site.",
      icon: "ri-government-line",
    },
    {
      id: "wausau-3",
      name: "Rothschild Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Brown Blvd",
      city: "Rothschild",
      state: "WI",
      zip: "54474",
      phone: "(715) 359-1600",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 5 miles south of downtown Wausau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Rothschild, Schofield, and Weston residents. Good alternative when Wausau facilities are busy.",
      icon: "ri-mail-line",
    },
    {
      id: "wausau-4",
      name: "Stevens Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1128 Main St",
      city: "Stevens Point",
      state: "WI",
      zip: "54481",
      phone: "(715) 344-2544",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "Approximately 30 miles south of downtown Wausau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Stevens Point, UW-Stevens Point campus, and Portage County. Major acceptance facility for southern Marathon County area.",
      icon: "ri-mail-line",
    },
    {
      id: "wausau-5",
      name: "Merrill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "430 E 2nd St",
      city: "Merrill",
      state: "WI",
      zip: "54452",
      phone: "(715) 536-4300",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 20 miles north of downtown Wausau",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern Marathon County and Lincoln County facility. Convenient for Merrill and Tomahawk area residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4-hr drive to Chicago via I-39/I-90 (8-hr roundtrip)", fpc: "No — ship from Wausau, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Central WI Business Travel", agency: "No special support for professionals", fpc: "Experienced with central Wisconsin business and insurance industry travelers" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Wausau residents are over 240 miles from the nearest passport agency. Routine processing takes 8–11 weeks through standard mail. Central Wisconsin travelers should start expedited service at least 6 weeks before departure — especially for summer family travel.",
    },
    {
      icon: "ri-car-line",
      title: "Planning a Day Trip to Chicago",
      description: "Driving from Wausau to the Chicago Passport Agency is 4 hours each way — an 8-hour roundtrip plus time at the agency. And they still require a pre-scheduled appointment. Our courier service eliminates this wasted day entirely.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Retail photo services in central Wisconsin sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background — no glasses, no smiling with teeth showing.",
    },
    {
      icon: "ri-file-list-line",
      title: "Confusing DS-82 vs DS-11",
      description: "Central Wisconsin residents often grab the wrong form. DS-82 is only for adult renewals where you have your current passport in hand. Everything else needs DS-11 and an acceptance facility visit.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Seasonal Demand",
      description: "Wausau area acceptance facilities see spikes during late spring and early summer as families prepare for vacation travel. Book appointments 3–4 weeks ahead during peak seasons.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity Requirements",
      description: "Many countries require 6 months of passport validity beyond your stay. Central Wisconsin business travelers to Europe and Asia frequently discover this requirement too late.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Wausau or Marathon County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx in the Wausau area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for central Wisconsin documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — no 8-hour roundtrip needed." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wausau address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Wausau, WI?", a: "Fast Passport Center offers emergency passport processing in Wausau, Wisconsin in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St, Chicago) — no need to make the 8-hour roundtrip drive yourself." },
    { q: "Does Wausau have its own passport agency?", a: "No. Wisconsin has no regional passport agency. The nearest is the Chicago Passport Agency, approximately 240 miles southeast (about 4 hours via I-39 and I-90). Fast Passport Center's courier service means central Wisconsin residents never need to make that trip." },
    { q: "What is the fastest way to get a passport in central Wisconsin?", a: "Fast Passport Center's expedited courier service is the fastest option for Wausau and central Wisconsin. Our couriers deliver to the Chicago Passport Agency, achieving 24–48 hour turnaround for emergencies and 2–9 business days for standard expedited service." },
    { q: "What airport do Wausau travelers use?", a: "Central Wisconsin Airport (CWA) serves the Wausau area with domestic connections to major hubs. Most international travelers connect through Minneapolis-St. Paul (MSP) or Chicago O'Hare (ORD). A valid passport is required for all international connections." },
    { q: "How much does an expedited passport cost in Wausau?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Wausau?", a: "Walgreens (multiple Wausau locations including 101 N 18th Ave), CVS (204 N 3rd Ave), and the UPS Store (225490 Rib Mountain Dr) all offer passport photo services. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Stevens Point and Marshfield residents?", a: "Yes. Fast Passport Center serves all of central Wisconsin including Wausau, Stevens Point, Marshfield, Merrill, Antigo, Tomahawk, and all of Marathon, Portage, and Wood counties. Our courier service works the same for everyone throughout the region." },
    { q: "Can I drive to Minneapolis instead of Chicago for a passport from Wausau?", a: "No. The Minneapolis Passport Agency only serves Minnesota residents. Even though it's closer to Wausau than Chicago (about 180 miles), Wisconsin residents are required to use the Chicago Passport Agency. Fast Passport Center's courier service handles the Chicago delivery for you." },
  ],
  photoLocations: [
    { name: "Walgreens — Wausau (18th Ave)", address: "101 N 18th Ave, Wausau, WI 54401", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Wausau (3rd Ave)", address: "204 N 3rd Ave, Wausau, WI 54401", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Rib Mountain", address: "225490 Rib Mountain Dr, Wausau, WI 54401", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Stevens Point", address: "5453 US-10, Stevens Point, WI 54481", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "WI DMV — Wausau", address: "2801 Sherman St, Wausau, WI 54401", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Central Wisconsin DMV serving Wausau and Marathon County. REAL ID and driver's license renewals. Appointment recommended.", featured: true },
    { name: "WI DMV — Stevens Point", address: "3505 Northpoint Dr, Stevens Point, WI 54481", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Portage County DMV. Alternative for southern Marathon County residents.", featured: false },
  ],
  airports: [
    {
      code: "CWA",
      name: "Central Wisconsin Airport",
      distance: "10 miles south of downtown Wausau, near Mosinee",
      address: "100 CWA Dr, Mosinee, WI 54455",
      note: "Central Wisconsin's regional airport serving Wausau, Stevens Point, and Marshfield. Domestic connections to major hubs. International travelers connect through MSP, ORD, or DTW.",
      flightUrl: "https://www.fly-cwa.org/",
      flightLabel: "CWA Airport",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-St. Paul International Airport",
      distance: "180 miles west of Wausau — approximately 3 hours via I-94",
      address: "4300 Glumack Dr, St Paul, MN 55111",
      note: "Major international hub for central Wisconsin travelers. Delta hub with extensive international routes across six continents. Closer than Chicago for Wausau area residents.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "240 miles southeast of Wausau — approximately 4 hours via I-39/I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub. Most Wausau travelers prefer MSP for convenience, but ORD offers additional international route options.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "O'Hare Airport",
      featured: false,
    },
  ],
};